import React from 'react';
import LocalDate from '../../LocalDate/LocalDate';
import { Container } from '@plone/components';

const ModificationDateView = (props) => {
  const { content, data, properties } = props;
  const modified = content?.modified || properties?.modified || null;
  const texto = data?.text || 'Dados atualizados em: ';
  return (
    modified && (
      <Container className={`block modification-date`}>
        <Container narrow>
          <p className="date">
            {texto}{' '}
            <LocalDate date={modified} includeTime={data?.long || false} />
          </p>
        </Container>
      </Container>
    )
  );
};

export default ModificationDateView;
